<script lang="ts" setup>
import type { CasinoGameItemExtend } from '~/types/game'
import { GAME_CASINO_LIMIT, PAYLOAD_LIVESTREAM } from '~/constants'
import { SlidersPerView, KeyEnum } from '~/enums'
import cacheManager from '#lib/utils/cache-manager'

const { isMobile } = useDevice()

const swiperOptions = {
  slidesPerGroup: isMobile ? 1 : 3,
  grabCursor: true,
  mousewheel: false,
  observer: true,
  observeParents: true,
  loop: false,
  slidesPerView: SlidersPerView.ExtremeSmall,
  spaceBetween: isMobile ? 12 : 24,
  slidesOffsetAfter: isMobile ? 16 : 0,
  navigation: !isMobile
    ? {
        prevEl: '.live-swiper-prev',
        nextEl: '.live-swiper-next',
      }
    : undefined,
  breakpoints: {
    560: {
      slidesPerView: SlidersPerView.MediumSmall,
    },
    1200: {
      slidesPerView: SlidersPerView.MediumSmall,
    },
  },
}

const ITEM_VIEW = 3
const isLoading = ref(true)

const { fetchLiveCasinoIndirect } = useCasino({
  gameLimit: GAME_CASINO_LIMIT,
})

const fetchAllGames = async (): Promise<CasinoGameItemExtend[]> => {
  const cachedData = cacheManager.get(KeyEnum.HomeLivestreamLiveCasino)
  if (cachedData) {
    isLoading.value = false
    return cachedData
  }
  try {
    const dataGames = await fetchLiveCasinoIndirect({
      limit: -1,
      groups: PAYLOAD_LIVESTREAM,
    })
    cacheManager.set(KeyEnum.HomeLivestreamLiveCasino, dataGames ?? [])
    return dataGames ?? []
  } catch {
    return []
  } finally {
    isLoading.value = false
  }
}

const { data: liveCasinoGames } = useAsyncData(
  KeyEnum.HomeLivestreamLiveCasino,
  fetchAllGames,
)
</script>

<template>
  <div
    v-if="liveCasinoGames?.length"
    class="wrapper-livestream-section"
    :class="{ 'livestream-section-mobile': isMobile }"
  >
    <BaseSection
      title="Livestream"
      icon="icon-live"
      custom-class="livestream-section"
    >
      <BaseSwiper
        :items="liveCasinoGames"
        :options="swiperOptions"
        :item-slides-per-view="ITEM_VIEW"
      >
        <template #item="{ item }: { item: CasinoGameItemExtend }">
          <CommonLivestreamItem :item="item" />
        </template>
      </BaseSwiper>
    </BaseSection>
  </div>
</template>
<style scoped lang="scss">
@import '~/assets/styles/components/desktop/home/casino-livestream.scss';
</style>
